import DeleteActivity from "./DeleteActivity";

export default DeleteActivity;